import React, { useMemo, useRef, useEffect, useState } from 'react'
import styled, { keyframes } from 'styled-components';
import { Link } from "gatsby";
import WaveSection from './WaveSection'
import { useTranslation } from 'react-i18next';
const TagSliderWave = ({tags, showAllLink, title}) => {
  const [rowWidths, setRowWidths] = useState([0, 0, 0]);
  const rowRefs = [useRef(null), useRef(null), useRef(null)];
  const { t } = useTranslation()
  const titleContent = title || t('tagSlider.title')
  const [firstRow, secondRow, thirdRow] = useMemo(() => {
    const chunkSize = Math.ceil(tags.length / 3);
    const filteredTags = tags.filter(tag => tag.label !== '' && tag.label !== 'Audiodesires Team')
    
    return [
      filteredTags.slice(0, chunkSize),
      filteredTags.slice(chunkSize, chunkSize * 2),
      filteredTags.slice(chunkSize * 2)
    ];
  }, [tags]);

  useEffect(() => {
    const updateRowWidths = () => {
      setRowWidths(rowRefs.map(ref => ref.current ? ref.current.scrollWidth : 0));
    };

    updateRowWidths();
    window.addEventListener('resize', updateRowWidths);
    return () => window.removeEventListener('resize', updateRowWidths);
  }, [tags]);

  const renderRow = (rowItems, index) => (
    <RowWrapper $direction={index % 2 === 0 ? "left" : "right"} ref={rowRefs[index]} $rowWidth={rowWidths[index]}>
      {rowItems.map((tag, idx) => (
        <React.Fragment key={`${tag.link}-${index}`}>
          {idx > 0 && <Separator>•</Separator>}
          <TagLink to={tag.link}>
            <TagItem>
              <TagLabel>{tag.label}</TagLabel>
            </TagItem>
          </TagLink>
        </React.Fragment>
      ))}
      {rowItems.map((tag, idx) => (
        <React.Fragment key={`duplicate-${tag.link}-${index}`}>
          {idx === 0 && <Separator>•</Separator>}
          <TagLink to={tag.link}>
            <TagItem>
              <TagLabel>{tag.label}</TagLabel>
            </TagItem>
          </TagLink>
          <Separator>•</Separator>
        </React.Fragment>
      ))}
    </RowWrapper>
  );

  return (
 
      <WaveSection>
      
      <Title>{titleContent}</Title>
      {/* <Subtitle>We have a lot of different erotic audio stories for lots of different fantasies and kinks. </Subtitle> */}
      <Wrapper>
        {renderRow(firstRow, 0)}
        {renderRow(secondRow, 1)}
        {renderRow(thirdRow, 2)}
      </Wrapper>
      {showAllLink && <ShowAllLink to={showAllLink}>Show all</ShowAllLink>}
      </WaveSection>
  
  )
}

export default TagSliderWave

const ShowAllLink = styled(Link)`
  font-size: 1rem;
  font-family: 'Poppins';
  margin: 0px;
  margin-top: 24px;
  position: absolute;
  bottom: 80px;
  text-align: center;
  padding: 10px 15px;
  background: #F19D9A;
  color: white;
  border-radius: 25px;
  text-decoration: none;
  cursor: pointer;
  text-transform: uppercase;
  white-space: nowrap;
  &:hover {
    color: white;
    background: #D98179;
  }
  height: 45px;
`

const Subtitle = styled.h3`
  font-size:12px;
  font-family: 'Poppins';
  margin: 0px;
  margin-bottom: 20px;
  text-align: center;
`

const Title = styled.h2`
  font-size:24px;
  margin: 0px 0px;
  text-align: center;
  
`

const TagItem = styled.div`
  padding:5px 10px;
  margin-left:5px;
  margin-top:5px;
  border-radius: 5px;
    /* background: white; */
  
`;

const Wrapper = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  overflow: hidden;
  margin-top: 16px;
`;

const moveLeft = (distance) => keyframes`
  from { transform: translateX(0); }
  to { transform: translateX(${-distance}px); }
`;

const moveRight = (distance) => keyframes`
  from { transform: translateX(${-distance}px); }
  to { transform: translateX(0); }
`;

const RowWrapper = styled.div`
  display: flex;
  white-space: nowrap;
  animation: ${props => props.$direction === 'left' ? moveLeft(props.$rowWidth / 2) : moveRight(props.$rowWidth / 2)} ${props => props.$rowWidth / 50}s linear infinite;
  
  &:hover {
    animation-play-state: paused;
  }
`;

const TagLink = styled(Link)`
  text-decoration:none;
`
const ItemSize = "20px"

const TagLabel  = styled.p`
  font-family: 'Poppins';
  text-transform: uppercase;
  font-weight: 1000;
  letter-spacing: 10px;
  white-space: nowrap;
  margin: 0;
  font-size: ${ItemSize};
  color:black;
  border-bottom:2px solid black;
  line-height: ${ItemSize};
  padding: 0px 5px;
`;

const Separator = styled.span`
  font-size: ${ItemSize};
  color: black;
  margin: 0 10px;
  line-height: 40px;
`;